import React from 'react';
import Header from './Header';
import Footer from './Footer';
import GlobalState, {
    Context
} from 'shared/context/GlobalState';
import '../../App.css';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import Notifcation from 'shared/components/Notifcation';
import {
    Outlet
} from 'react-router-dom';
import {
    RouteErrorBoundary
} from 'shared/components/ErrorBoundary';

export default function Wrapper({
    children
}) {

    const store = GlobalState();

    return (
        <Context.Provider value={store}>
            <div className='bex-container bg-gray-100 dark:bg-background'>
                <Notifcation />
                {store.loading ? <AppLoader size={30} /> : (
                    <>
                        {children}
                    </>
                )}
            </div>
        </Context.Provider>
    );
}

export const Layout = () => {

    return (
        <>
            <Header />
            <main>
                {/* Tier 2 — a page that throws leaves the header, footer and
                    navigation mounted, so the user can walk away from the bad
                    record instead of refreshing into the same crash. Keyed on
                    pathname so navigating clears the error. */}
                <RouteErrorBoundary name="layout-outlet">
                    <Outlet />
                </RouteErrorBoundary>
            </main>
            <Footer />
        </>
    );
};
